import { Pipe, PipeTransform } from '@angular/core';
import { FormType } from '../models/form.model';

const LABELS: Record<FormType, string> = {
  INLINE:     'Incrustado',
  POPUP:      'Pop-up',
  STICKY_BAR: 'Barra fija',
  SLIDE_IN:   'Deslizante',
};

@Pipe({ name: 'formTypeLabel', standalone: true, pure: true })
export class FormTypeLabelPipe implements PipeTransform {
  transform(type: FormType): string {
    return LABELS[type] ?? type;
  }
}
